var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9323 7.30009H3.11311L8.40471 2.20696C8.68179 1.94026 8.69253 1.49716 8.4286 1.21717C8.16503 0.937521 7.72654 0.926321 7.44911 1.19302L1.40593 7.00995C1.14443 7.27454 1 7.62594 1 8.00009C1 8.37388 1.14443 8.72563 1.41805 9.00177L7.44946 14.8068C7.5835 14.936 7.75529 15 7.92708 15C8.10996 15 8.29283 14.9272 8.42895 14.7827C8.69287 14.5027 8.68214 14.0599 8.40505 13.7932L3.09129 8.70008H16.9323C17.3147 8.70008 17.625 8.38648 17.625 8.00009C17.625 7.61369 17.3147 7.30009 16.9323 7.30009Z",
    fill: "#01544E",
    stroke: "#01544E",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackSvg);
export default __webpack_public_path__ + "static/media/backSVG.8af50711.svg";
export { ForwardRef as ReactComponent };